import { get, IResponseError, post, put, remove } from 'communication/httpClient';
import {
  LOAD_TAX_PARAMETERS,
  TAX_PARAMETERS_LOADED,
  SAVE_TAX_PARAMETER,
  TAX_PARAMETER_SAVED,
  TAX_PARAMETER_DELETED,
  RESET_TAX_PARAMETERS,
  RESET_SEARCH_TAX_PARAMETERS,
  SYNC_FAILED,
} from './actionTypes';

export const initialActionsState = {
  loadTaxParameters: () => {},
  addTaxParameter: () => {},
  deleteTaxParameter: () => {},
  resetTaxParameters: () => {},
  resetSearchTaxParameters: () => {},
};

export const getActions = (dispatch: {
  (value: { type: any; payload?: any }): void;
  (arg0: { type: string; payload?: any }): void;
}) => ({
  loadTaxParameters: async (params) => {
    dispatch({
      type: LOAD_TAX_PARAMETERS,
    });

    const { data, error } = await get(`/api/tax-parameters?${new URLSearchParams(params)}`);

    if (data) {
      dispatch({
        type: TAX_PARAMETERS_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  addTaxParameter: async (values: any, id?: string, onDone?: (error?: IResponseError) => void) => {
    dispatch({
      type: SAVE_TAX_PARAMETER,
    });
    const handler = id ? put : post,
      resourceId = id || '';
    const { data, error } = await handler(`/api/tax-parameters/${resourceId}`, values);

    if ((data || data === '') && !error) {
      dispatch({
        type: TAX_PARAMETER_SAVED,
        payload: values,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }

    if (onDone) onDone(error);
  },
  deleteTaxParameter: async (id: string, callback?: (id: string) => void) => {
    const { data, error } = await remove('/api/tax-parameters/' + id);
    if ((data || data === '') && !error) {
      dispatch({
        type: TAX_PARAMETER_DELETED,
        payload: id,
      });
      if (callback) {
        callback(id);
      }
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  resetTaxParameters: () =>
    dispatch({
      type: RESET_TAX_PARAMETERS,
    }),
  resetSearchTaxParameters: () =>
    dispatch({
      type: RESET_SEARCH_TAX_PARAMETERS,
    }),
});
